import MapAlert from "features/CenterContent/RoleContent/VehicleMap/MapAlert";
import { Wrapper } from "features/CenterContent/RoleContent/VehicleMap/VehicleMap";
import VehicleMapLayers from "features/CenterContent/RoleContent/VehicleMap/VehicleMapLayers";
import { BusGpsData } from "features/CenterContent/shared/types";
import { busGpsDataToBaseGpsData } from "features/CenterContent/shared/utils";
import { useVyatDataGPS } from "features/VehicleSidebar/VehicleList/AlternativeTransportList/useVyAtData";
import { Alert, Grid, GridItem } from "shared/components/Spor";

export const VehicleMapBus = () => {
  const { vyAtData: vyAtDataGPS, isError: isErrorGPS } = useVyatDataGPS();

  const mappedVyatGPSData: BusGpsData[] =
    vyAtDataGPS?.operationalVehicles.map((busGps) => ({
      timestamp: new Date(busGps.latestLocation.timestamp).toISOString(),
      gps: {
        longitude: parseFloat(busGps.latestLocation.longitude),
        latitude: parseFloat(busGps.latestLocation.latitude),
      },
      phoneNumber: busGps.phoneNumber,
      workshiftId: busGps.workshiftId,
      trainNumber: busGps.trainNumber,
      id: [busGps.workshiftId, busGps.trainNumber].filter(Boolean).join(" - "),
      closestNeighbor: null,
      path: null,
    })) ?? [];

  return (
    <Wrapper
      position="relative"
      height="100%"
      width="100%"
      align="center"
      justify="center"
    >
      <Grid
        position="absolute"
        alignItems="center"
        column={2}
        top={8}
        left={0}
        p="12px"
        gap="12px"
        zIndex={1000}
      >
        <GridItem colSpan={2}>
          <MapAlert isError={isErrorGPS} hasNoResults={false} query="" />
          {isErrorGPS && <Alert data-color="critical" mt={2} />}
        </GridItem>
      </Grid>

      <VehicleMapLayers
        searchPhoneNumber
        gpsData={busGpsDataToBaseGpsData(mappedVyatGPSData)}
        query=""
      />
    </Wrapper>
  );
};
